import { filtersOptions } from './filtersOptions';
import { State } from 'xstate';

export type FiltersOptionsMachine = typeof filtersOptions;

export type FiltersOptionsMachineState = State<
  FiltersOptionsMachine['context']
>;

export const getProducts = (machineState: FiltersOptionsMachineState) => ({
  products: machineState.context.products,
});

export const filtersOptionsSelectors = {
  getProducts,
};
